module.exports = __webpack_public_path__ + "img/user.d961d73a.png";